import React from 'react'
import { connect } from 'react-redux'
import { Grid, Row } from 'react-bootstrap'
import Dashboard from '../../components/Dashboard'
import Breadcrumbs from '../../components/Breadcrumbs'
import ChangeUserId from './pages/ChangeUserId'
import LicenseBlock from './pages/LicenseBlock'
import LicenseAdjustDeactivateBefore from './pages/LicenseAdjustDeactivateBefore'
import ProductEditionOverview from './pages/ProductEditionOverview'
import OrderBlock from './pages/OrderBlock'
import LicensesActivePerProductEan from './pages/LicensesActivePerProductEan'
import LicenseEditionOverview from './pages/LicenseEditionOverview'
import UserInfoPerProductEanOverview from './pages/UserInfoPerProductEanOverview'
import UpdateUserFederatedIdentityId from './pages/UpdateUserFederatedIdentityId'
import UserInfoOverview from './pages/UserInfoOverview'


class DashboardMain extends React.Component { 

    constructor() {
        super()
        this.state = { mode:undefined }
    }

    setMode(mode) {
      this.setState({mode: mode})
    }

    render() { 
        const Content = () => {

          switch(this.state.mode) {
            case 1:
              return <ChangeUserId />;
            case 2:
              return <LicenseAdjustDeactivateBefore/>
            case 3:
              return <LicenseBlock/>
            case 4: 
              return <OrderBlock/>
            case 5:
              return <ProductEditionOverview/>
            case 6:
              return <LicensesActivePerProductEan/>
            case 7:
              return <LicenseEditionOverview/>
            case 8:
              return <UserInfoPerProductEanOverview/>
            case 9:
              return <UpdateUserFederatedIdentityId/>
            case 10:
              return <UserInfoOverview/>
            default:
              return <></>;
          }

        }
        return <div className='content' >
        <Grid style={{backgroundColor:"white", padding:"10px"}}>
          <Row>
            <Breadcrumbs style={{ padding:"10px"}}/>
                <span className="title">
                        <b>IAM Dashboard</b>
                </span>
          </Row>
          <Row>
            <Dashboard
              callback={(mode) => this.setMode(mode)}
            />
          </Row>
          <Content/>
        </Grid>
        </div>
    }
}

export default connect((state) => { return { newUserId: state }})(DashboardMain)
